import React from 'react';
import { Modal, Backdrop, Typography, Button, styled } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import './index.css';

interface InfoMessageModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  content: string | React.ReactNode; // Support pour JSX
}

const StyledModal = styled(Modal)`
  position: fixed;
  z-index: 1300;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledBackdrop = styled(Backdrop)`
  z-index: -1;
  position: fixed;
  inset: 0;
  background-color: rgb(0 0 0 / 0.5);
  -webkit-tap-highlight-color: transparent;
`;

const ModalContent = styled('div')`
  width: 500px;
  max-width: 90vw;
  border-radius: 12px;
  padding: 24px 32px;
  background-color: white;
  box-shadow: 0px 2px 24px #383838;
  position: relative;
  max-height: 80vh;
  overflow-y: auto;
`;

const CloseButton = styled(Button)`
  position: absolute;
  top: 16px;
  right: 16px;
  min-width: auto;
  padding: 8px;
  color: #666;
  
  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
`;

const Title = styled(Typography)`
  font-weight: 600;
  color: #124376;
  margin-bottom: 16px;
  padding-right: 40px;
`;


const ActionButton = styled(Button)`
  background-color: #124376;
  color: white;
  padding: 12px 24px;
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  
  &:hover {
    background-color: #0f3560;
  }
`;

export default function InfoMessageModal({ 
  open, 
  onClose, 
  title, 
  content 
}: InfoMessageModalProps) {
  return (
    <StyledModal
      open={open}
      onClose={onClose}
      BackdropComponent={StyledBackdrop}
    >
      <ModalContent>
        <CloseButton onClick={onClose}>
          <CloseIcon />
        </CloseButton>
        
        <Title variant="h5">
          {title}
        </Title>
        
        <div style={{ color: '#333', lineHeight: 1.6, marginBottom: '24px' }}>
          {content}
        </div>
        
        <div style={{ textAlign: 'right' }}>
          <ActionButton onClick={onClose}>
            J'ai compris
          </ActionButton>
        </div>
      </ModalContent>
    </StyledModal>
  );
}
